import React from "react";
import ProductOption from "./ProductOption";
import SaasProductOption from "./saas/SaasProductOption"
import { connect } from "react-redux";
import {
  addProductSelection,
  deleteProductSelection,
  updateProductSelectionQty,
  updateProductSelectionTargetPrice
} from "../redux/actions";
import style from "./BundleOptions.module.css";

function BundleOptions(props) {
  const getActiveSelectionIds = optionId =>
    props.pickedOptionSelections
      .filter(o => o.optionId === optionId)
      .flatMap(o => o.selections.map(s => s.selectionId));

  /**
   * Handle option selection click
   *
   * @param option
   * @param selection
   * @param action "add" or "remove"
   */
  const handleOptionSelectionClick = (option, selection, action) => {
    const allOptions = props.availableOptions;

    // Toggle the selection
    action === "add"
      ? props.addProductSelection({
        option,
        selection,
        allOptions,
        action
      })
      : props.deleteProductSelection({
        option,
        selection,
        allOptions,
        action
      });
  };

  /**
   * Given the selection,
   * get the extra selections by the product attribute "additional_linked_part"
   *
   * @param selection
   * @returns {option, selection}[]
   */
  const getLinkedSelections = selection =>
    [
      ...new Set(
        (selection.product.additional_linked_part || "")
          .split(",")
          .map(sku => sku.trim())
          .filter(sku => sku !== "")
          // Avoid loop reference
          .filter(sku => sku !== selection.product.sku)
      )
    ]
      .map(sku =>
        // Find the first matching option/selection pair
        props.availableOptions
          .map(o => ({
            option: o,
            selection: o.selections.find(s => s.product.sku === sku)
          }))
          .filter(item => item.selection !== undefined)
          .shift()
      )
      .filter(item => item !== undefined);

  return (
    <div className={style.root}>
      {props.availableOptions.map(option => {
        return (
          props.isSaas
            ? <SaasProductOption 
            key={option.option_id}
            option={option}
            activeSelectionIds={getActiveSelectionIds(option.option_id)}
            handleOptionSelectionClick={handleOptionSelectionClick}
            handleQtyChange={props.updateProductSelectionQty}
            handleTargetPriceChange={props.updateProductSelectionTargetPrice}
            getLinkedSelections={getLinkedSelections}
            availableOptions={props.availableOptions} />
            
            : <ProductOption
            key={option.option_id}
            option={option}
            activeSelectionIds={getActiveSelectionIds(option.option_id)}
            handleOptionSelectionClick={handleOptionSelectionClick}
            handleQtyChange={props.updateProductSelectionQty}
            getLinkedSelections={getLinkedSelections}
            availableOptions={props.availableOptions}
          />
        );
      })}
    </div>
  );
}

export default connect(
  ({ product }) => ({
    pickedOptionSelections: product.pickedOptionSelections,
    availableOptions: product.availableOptions
  }),
  { updateProductSelectionQty, addProductSelection, deleteProductSelection, updateProductSelectionTargetPrice }
)(BundleOptions);
